import { render, staticRenderFns } from "./Requests.html?vue&type=template&id=d1428d5a&external"
import script from "./Requests.js?vue&type=script&lang=js&external"
export * from "./Requests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports